import React from "react";
import { ServiceRequestsModule } from "../../modules/Maintenance/ServiceRequests";

const ServiceRequests = () => {
  return <ServiceRequestsModule />;
};

export default ServiceRequests;
